// extracted by mini-css-extract-plugin
export default {"container":"icGn0v","ballOne":"Yu19Bc","ballTwo":"VaiN8d","ballThree":"d0AljU","bouncedelay":"UrFR6_"};